<template>
    <section class="contacts">
        <h1 class="contacts__title">{{ $t('com.file.nav-data.presence-reports') }}</h1>

        <section class="edit-meeting__row-double">
            <section class="edit-meeting__col-double">
                <label class="edit-meeting__label">{{ $t('com.file.user-presence.date-from') }}:</label>
                <section class="edit-meeting__picker-wrapper">
                    <input type="date" class="edit-meeting__picker" v-model="from_date"
                        v-error="{ errors, input_key: 'from_date', }" />
                    <ErrorMessage v-if="isError('from_date', this.errors)"
                        :errorMsgs="passErrorMsg('from_date', this.errors)" />
                </section>
            </section>
            <section class="edit-meeting__col-double">
                <label class="edit-meeting__label">{{ $t('com.file.user-presence.date-to') }}:</label>
                <section class="edit-meeting__picker-wrapper">
                    <input type="date" class="edit-meeting__picker" style="width: 160px;" v-model="to_date"
                        v-error="{ errors, input_key: 'to_date', }" />
                    <ErrorMessage v-if="isError('to_date', this.errors)"
                        :errorMsgs="passErrorMsg('to_date', this.errors)" />
                </section>
            </section>
            <section class="edit-meeting__col-double">
                <label class="edit-meeting__label">{{ $t('com.file.export-registry-modal.group') }}:</label>
                <section class="meetings-settings__wrapper">
                    <select class="meetings-settings__select" v-model="selected">
                        <option v-for="s in groups" :key="s.id" :value="s.id"> {{ s.nazwa }}</option>
                    </select>
                </section>
            </section>
            <ButtonWithIcon icon="search" class="generate-button" :text="$t('com.file.user-presence.generate')"
                :classModified="true" @click="(e) => generatePresenceReport()" />
        </section>
        <section class="table_section" v-if="dataArr.length > 0">
            <ButtonWithIcon icon="download" class="download-button" style="margin-left: 10px;" text=".PDF"
                :classModified="true" @click="getPdfReport()" />

            <ButtonWithIcon icon="download" class="download-button" text=".DOC" :classModified="true"
                @click="getDocReport()" />
            <div>
                <h3>{{ client }}</h3>
                <p>{{ $t('com.file.user-presence.presence-report-period') }} {{ $t('com.file.user-presence.from') }}
                    {{ from_date }} {{ $t('com.file.user-presence.to') }} {{ to_date }}</p>
                <p v-if="tempGroupName != $t('com.file.user-presence.summary-report')">
                    {{ $t('com.file.export-registry-modal.group') }}: {{ tempGroupName }}</p>
                <TableComponent :search="search" :pagination="pagination" :fields="fields" :dataArr="dataArr" />
            </div>
        </section>
    </section>

</template>

<script>
import ButtonWithIcon from "../../../BasicControls/ButtonWithIcon.vue";
import moment from "moment";
import ToolsService from "../../../../services/tools.service";
import ContactService from '../../../../services/contact.service';
import PdfExportService from "../../../../services/pdf.export.service";
import TableComponent from '../../../../components/Table/TableComponent.vue'
import ErrorMessage from "../../../BasicControls/ErrorMessage.vue";
import { fileDownloadHelperWithName } from "@/helpers/file.download.helper";

import {
    passErrorMsg,
    isError,
    setErrors,
} from "../../../../formValidation/main";

export default {
    name: "presence",
    data() {
        return {
            chartData: {
                labels: [],
                datasets: [{ data: [] }]

            },
            plugins: [],
            tempdata: [],
            complex: [],
            dataArr: [],
            lastUserLoginsArr: [],
            showLastUsersLoginsModal: false,
            tempUserId: 0,
            tempUserName: '',
            pagination: true,
            fields: [this.$t('com.file.user-presence.lp'), this.$t('com.file.contact-box.name-and-surname-cap-letter'), this.$t('com.file.user-presence-modal.user-presence'), this.$t('com.file.user-presence-modal.user-absent'), this.$t('com.file.user-presence.delays'), this.$t('com.file.user-presence.early-exits')],
            search: false,
            from_date: moment(new Date()).format("YYYY-MM-DD"),
            to_date: moment(new Date()).format("YYYY-MM-DD"),
            errors: [],
            groups: [],
            selected: 0,
            client: '',
            tempGroupName: ''
        };
    },
    methods: {
        validate() {
            var bo = true;
            var err = {};

            if (this.from_date.length <= 0) {
                err.from_date = [this.$t('com.global.required-field')]
                bo = false
            }

            if (this.to_date.length <= 0) {
                err.to_date = [this.$t('com.global.required-field')]
                bo = false
            }

            if (moment(this.from_date, 'yyyy-MM-DD', true).isValid() == false) {
                err.from_date = [this.$t('com.validation-error.invalid-date-format')]
                bo = false
            }

            if (moment(this.to_date, 'yyyy-MM-DD', true).isValid() == false) {
                err.to_date = [this.$t('com.validation-error.invalid-date-format')]
                bo = false
            }

            if (Date.parse(this.to_date) < Date.parse(this.from_date)) {
                err.from_date = [this.$t('com.validation-error.invalid-time-range')]
                bo = false
            }

            if (!bo) {
                this.errors = setErrors(err)
            }
            return bo
        },
        async getDocReport() {
            try {
                this.$store.commit("showLoader");

                var grId = this.groups.find(x => x.id == this.selected).id;

                const t = {
                    groupId: grId,
                    dateFrom: new Date(this.from_date),
                    dateTo: new Date(this.to_date),
                };

                const result = await ToolsService.getDocPresenceReport(t);

                if (result.status === 200) {
                    const contentType = result.headers['content-type'];
                    let a = document.createElement('a');
                    var blob = new Blob([result.data], { 'type': contentType });
                    a.href = window.URL.createObjectURL(blob);
                    var filename = result.headers['content-disposition'].split("filename=")[1];

                    filename = filename.substr(0, filename.indexOf(';'));
                    filename = filename.replaceAll('"', '');
                    a.download = filename
                    a.click();
                }

            } catch (e) {
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            }
            finally {
                this.$store.commit("hideLoader");
            }
        },
        async getPdfReport() {
            try {
                this.$store.commit("showLoader");

                var grId = this.groups.find(x => x.id == this.selected).id;

                var t = {
                    groupId: grId,
                    dateFrom: new Date(this.from_date),
                    dateTo: new Date(this.to_date),
                };

                let result = await PdfExportService.getUserPresencePdfFile(t);

                if (result.status === 200) {
                    var filename = result.headers['content-disposition'].split("filename=")[1];
                    filename = filename.substr(0, filename.indexOf(';'));
                    filename = filename.replaceAll('"', '');

                    fileDownloadHelperWithName(result, filename);
                }

            } catch (e) {
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            }
            finally {
                this.$store.commit("hideLoader");
            }
        },
        createObj(_raw, _parsed) {
            return {
                raw: _raw,
                parsed: _parsed
            };
        },
        async generatePresenceReport() {
            try {
                this.errors = [];
                this.dataArr = [];
                if (this.validate() == false) {
                    return
                }

                this.$store.commit("showLoader");

                var grId = this.groups.find(x => x.id == this.selected).id;

                var t = {
                    groupId: grId,
                    dateFrom: new Date(this.from_date),
                    dateTo: new Date(this.to_date),
                };

                this.complex = (await ToolsService.getUserPresenceReport(t)).data;
                var count = 1;
                for (var j = 0; j < this.complex.up.length; j++) {
                    var temp = {
                        [this.$t('com.file.user-presence.lp')]: this.createObj(count, count + '.'),
                        [this.$t('com.file.contact-box.name-and-surname-cap-letter')]: this.createObj(this.complex.up[j].firstName + " " + this.complex.up[j].lastName, this.complex.up[j].firstName + " " + this.complex.up[j].lastName),
                        [this.$t('com.file.user-presence-modal.user-presence')]: this.createObj(this.complex.up[j].presence, this.complex.up[j].presence),
                        [this.$t('com.file.user-presence-modal.user-absent')]: this.createObj(this.complex.up[j].absence, this.complex.up[j].absence),
                        [this.$t('com.file.user-presence.delays')]: this.createObj(this.complex.up[j].late, this.complex.up[j].late + " " + this.$t('com.file.speech-timer-config.minutes2')),
                        [this.$t('com.file.user-presence.early-exits')]: this.createObj(this.complex.up[j].exit, this.complex.up[j].exit + " " + this.$t('com.file.speech-timer-config.minutes2')),
                        ID: this.createObj(this.complex.up[j].id, this.complex.up[j].id)
                    };
                    this.dataArr.push(temp);
                    count++;
                }
                this.client = this.complex.client;
                this.tempGroupName = this.groups.find(x => x.id == this.selected).nazwa;
                this.pagination = false;
            } catch (e) {
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            }
            finally {
                this.$store.commit("hideLoader");
            }
        },
        passErrorMsg,
        isError,
        setErrors,
    },
    components: {
        TableComponent,
        ErrorMessage,
        ButtonWithIcon
    },
    async mounted() {
        try {
            this.$store.commit("showLoader");


            let response = await ContactService.index(false);
            if (response.status !== 200) {
                throw await Promise.reject(response);
            }

            this.groups = response.data
                .filter(item => {
                    return item.can_sessions;
                })
                .map(item => (
                    {
                        nazwa: item.name,
                        id: item.id
                    }))
                .sort((a,b) => (a?.nazwa ?? '').localeCompare(b?.nazwa ?? '', this.$i18n.locale, { sensitivity: 'base', numeric: true }));

            var d = {
                nazwa: this.$t('com.file.user-presence.summary-report'),
                id: 0
            }
            this.groups.push(d);
        } catch (e) {
            if (e.response !== undefined) {
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            } else {
                console.log(e);
            }

        }
        finally {
            this.$store.commit("hideLoader");
        }
    },
};
</script>

<style lang="scss" scoped>
.generate-button {
    margin-top: 30px;
    margin-left: auto;
}

.download-button {
    margin-left: auto;
    margin-right: 0;
    float: right;
}

.table_section {
    background-color: white;
    border-radius: 10px;
    padding: 10px;
    margin-top: 20px;

    h3 {
        padding: 10px;
    }

    p {
        padding: 10px;
    }
}

.chart_section {
    background-color: white;
    border-radius: 10px;
    max-height: 500px;
    padding: 10px;
}

.meetings-settings {
    margin-top: 20px;

    &__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
    }

    &__wrapper {
        position: relative;
        /* &::after {
                content: "";
                position: absolute;
                top: 8px;
                background: #e2e5eb;
                width: 1px;
                height: 24px;
                right: 40px;
                z-index: 99;
            }*/
    }

    &__select {
        background: #ffffff;
        border: 1px solid #d1d6df;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.08);
        border-radius: 4px;
        padding: 8px 10px 8px 16px;
        font-weight: normal;
        font-size: 14px;
        line-height: 145%;
        color: #00082c;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("../../../../assets/icons/components/select-arrow.svg");
        background-repeat: no-repeat;
        background-position-x: calc(100% - 14px);
        background-position-y: 50%;
        min-width: 300px;
        min-height: 56px;

        &:focus {
            outline: none;
        }
    }
}

.contacts {
    margin: 49px 48px;

    &__title {
        font-weight: 600;
        font-size: 28px;
        line-height: 128%;
        color: #00082c;
        margin-bottom: 20px;
    }

    &__add-user-btn {
        position: fixed;
        bottom: 40px;
        right: 48px;
        width: 56px;
        height: 56px;
        border: 0px;
        background: #d80418;
        box-shadow: 8px 8px 28px rgba(173, 3, 19, 0.16);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2 ease-in-out;

        &:hover {
            background: #ad0313 !important;
        }
    }

    &__add-user-btn-icon {
        width: 25px;
        height: 24px;
    }
}

.contact-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    &__input {
        height: 48px;
        background: #ffffff;
        border: 1px solid #d1d6df;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.08);
        border-radius: 4px;
        width: 326px;
        box-sizing: border-box;
        padding: 12.5px 16px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        border-right: 0px;

        &:focus {
            border: 1px solid #00082c;
        }
    }

    &__button-search {
        height: 48px;
        background: #ffffff;
        border: 1px solid #d1d6df;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.08);
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        border-left: 0px;
        position: relative;
        cursor: pointer;

        &::after {
            content: "";
            position: absolute;
            width: 1px;
            height: 32px;
            background: #e2e5eb;
            top: 8px;
            left: 0px;
        }
    }

    &__form {
        display: flex;
        align-items: center;
    }

    &__search-icon {
        padding: 14px;
    }

    &__action-buttons {
        display: flex;
    }
}

.contact-list-no-result {
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}


.edit-meeting {
    &__row-double {
        display: flex;
        //justify-content: space-between;
        margin-bottom: 24px;
    }

    &__col-double {
        display: flex;
        flex-direction: column;
        margin-right: 15px;
    }

    &__label {
        font-weight: 600;
        font-size: 14px;
        line-height: 145%;
        color: #00082c;
        margin-bottom: 8px;
    }

    &__picker {
        padding: 12.5px 16px;
        background: #ffffff;
        border: 1px solid #d1d6df;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
        border-radius: 4px;
        min-width: 238px;
        height: 56px;
        font-size: 16px;
        line-height: 144%;
        color: #00082c;

        &[type="date"]::-webkit-calendar-picker-indicator {
            color: rgba(0, 0, 0, 0);
            opacity: 1;
            display: block;
            background: url("../../../../assets/icons/components/callendar.svg") no-repeat;
            background-position-x: 100%;
            width: 22px;
            height: 22px;
            border-width: thin;
        }

        &[type="time"]::-webkit-calendar-picker-indicator {
            color: rgba(0, 0, 0, 0);
            opacity: 1;
            display: block;
            background: url("../../../../assets/icons/components/clock.svg") no-repeat;
            width: 22px;
            height: 22px;
            border-width: thin;
        }
    }

    &__picker-wrapper {
        position: relative;
        /*&::after {
                content: "";
                position: absolute;
                top: 8px;
                background: #e2e5eb;
                width: 1px;
                height: 40px;
                right: 56px;
                z-index: 99;
            }*/
    }
}

@media only screen and (max-width:1850px) {

    .edit-meeting {
        &__picker {
            min-width: 0 !important;
        }
    }
}
</style>